import React from "react";
import Call from "../../assets/svg/Call";
import Email from "../../assets/svg/Email";
import useAuth from "../../hooks/useAuth";

const Address = ({ onClick }) => {
  const { user } = useAuth();
  const defaultAddress = user?.addresses?.find((address) => address.default);
  return (
    <div>
      <div className="order-address-inner bg-white p-4 rounded-lg">
        <div className="flex justify-between items-center">
          <p className="text-[18px] supreme-bold">Delivery details</p>
          <button
            className="text-blue-600 supreme-medium tracking-wide text-[16px]"
            onClick={onClick}
          >
            Change
          </button>
        </div>
        <div className="selected-detailed-address">
          <p className="general-sans-medium text-[16px] mt-4">
            {defaultAddress?.name}
          </p>
          <p className="general-sans-regular text-[14px] mt-2 leading-[20px] tracking-wide">
            {defaultAddress?.address1 +
              " " +
              defaultAddress?.address2 +
              ", " +
              defaultAddress?.city +
              " " +
              defaultAddress?.province +
              ", " +
              defaultAddress?.zip}
          </p>
          <div className="mt-[8px] flex items-center gap-4 flex-wrap">
            {defaultAddress?.phone || user?.phone ? (
              <div className="flex items-center gap-1">
                <Call width={15} height={15} color="#6b7280" />
                <p className="general-sans-medium text-[15px] text-gray-400">
                  {defaultAddress?.phone
                    ? (defaultAddress?.phone).replace(/\D/g, "").slice(-10)
                    : (user?.phone).replace(/\D/g, "").slice(-10)}
                </p>
              </div>
            ) : null}
            {defaultAddress?.email || user?.email ? (
              <div className="flex items-center gap-1 overflow-hidden">
                <Email width={15} height={15} color="#6b7280" />
                <p className="general-sans-medium text-[15px] text-gray-400 break-words">
                  {defaultAddress?.email ? defaultAddress?.email : user?.email}
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Address;
